var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 320 330",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    strokeWidth: 24,
    stroke: "#efb0ff",
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    strokeWidth: 10,
    stroke: "#a440f2",
    r: 150
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.37449 227.74935L175.4838 92.41063C172.6135 85.41334 168.3467 82 162.7224 82h-4.4995c-5.6244 0-9.8911 3.41334-12.7615 10.41063l-22.1483 58.9654h-16.7567c-5.0038.04268-9.0766 4.47999-9.1154 10.02663v.12803c.0388 5.50396 4.1116 9.98395 9.1154 10.02663h8.9989l-21.1398 56.19203c-.3879 1.23725-.6206 2.5173-.6206 3.83991 0 3.15738.8921 5.632 2.4825 7.55201S100.1562 242 103.0266 242c1.9007-.04268 3.7237-.68265 5.2365-1.92001 1.6291-1.23737 2.754-3.02934 3.6461-5.07739l23.2732-63.48796h16.1361c5.0037-.04268 9.0765-4.47999 9.1153-10.02662v-.25608c-.0388-5.50396-4.1116-9.98395-9.1153-10.02663h-8.6111l17.7652-48.6827 48.40829 132.43731c.8921 2.04805 2.017 3.84003 3.6461 5.07739 1.5127 1.23736 3.3746 1.87733 5.2364 1.92001 2.8704 0 5.1202-.93872 6.7493-2.85862s2.4825-4.39474 2.4825-7.55201c.0387-1.28004-.1552-2.60265-.6207-3.79734z",
    stroke: "#efb0ff",
    strokeWidth: 7,
    fill: "#a440f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.2884c51fd9d59d72f644e6d7acca6c53.svg";
export { ForwardRef as ReactComponent };